import { render, staticRenderFns } from "./PacienteLayout.vue?vue&type=template&id=896a0bd8&"
import script from "./PacienteLayout.vue?vue&type=script&lang=js&"
export * from "./PacienteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports